var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 1.33325C9.89099 1.33325 7.8287 1.95884 6.07457 3.13091C4.32045 4.30298 2.95328 5.96888 2.14594 7.91796C1.33861 9.86704 1.12737 12.0118 1.53895 14.0809C1.95052 16.15 2.96642 18.0506 4.45818 19.5424C5.94994 21.0342 7.85056 22.0501 9.91969 22.4616C11.9888 22.8732 14.1335 22.662 16.0826 21.8546C18.0317 21.0473 19.6976 19.6801 20.8697 17.926C22.0417 16.1719 22.6673 14.1096 22.6673 11.9999C22.6673 9.17094 21.5435 6.45783 19.5431 4.45745C17.5427 2.45706 14.8296 1.33325 12.0007 1.33325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 8.06666C18.5411 7.9425 18.3721 7.8728 18.196 7.8728C18.0198 7.8728 17.8509 7.9425 17.726 8.06666L10.326 15.4333L6.32597 11.4333C6.20397 11.3016 6.03464 11.2237 5.85523 11.2169C5.67582 11.21 5.50103 11.2747 5.36931 11.3967C5.23758 11.5187 5.15972 11.688 5.15284 11.8674C5.14596 12.0468 5.21064 12.2216 5.33264 12.3533L10.326 17.3333L18.666 9.01333C18.7285 8.95136 18.7781 8.87762 18.8119 8.79638C18.8457 8.71514 18.8632 8.62801 18.8632 8.54C18.8632 8.45199 18.8457 8.36485 18.8119 8.28361C18.7781 8.20237 18.7285 8.12864 18.666 8.06666Z",
    fill: "#32B16E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.837dd532b91f4870128f51d2a6786a19.svg";
export { ForwardRef as ReactComponent };